/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import BoardFrontierType from 'solis/logic/board/frontier.type';
import BoardProximity from 'solis/logic/board/proximity';
import BoardSectorGeometry from 'solis/logic/board/sector/geometry';


export default class BoardTransfer extends Logic
{
  constructor (board)
  {
    super(board);

    this.proximity = new BoardProximity(board, BoardFrontierType.Sector);
  }


  shouldTransfer (sector)
  {
    return !this.proximity.isGroupAccessibleByColony(this.getZoneGroup(sector), sector.cass.colony);
  }


  // [cpp-diff] A sector nothing reaches stays with its colony instead of becoming a new colony.
  // Colony that lost its core keeps a single outline.
  getTargetColony (sector)
  {
    return this.proximity.getClosestColony(this.getZoneGroup(sector)) ?? sector.cass.colony;
  }


  getZoneGroup (sector)
  {
    return new BoardSectorGeometry(sector).getZoneGroup(BoardFrontierType.Sector);
  }


};
